<template>
  <div class="bb-notification"
       :class="{'bb-notification_open': openNotifications}"
       v-click-outside="hideNotificationBar"
  >
    <div class="bb-notification-header">
      <h3 class="bb-notification-header__title">Notifications</h3>
      <span class="bb-notification-header__count" v-if="countNotifications">
        {{countNotifications}}
      </span>
      <i
        v-if="countNotifications"
        class="icon-menu bb-notification-header__icon"
        @click="isShowPopup = !isShowPopup"
      />
      <transition name="bounce">
        <NotificationsBarPopupMenu
          v-if="isShowPopup"
          :isShowPopup.sync="isShowPopup"
          :notificationsList.sync="notificationsList"
          :userInfo="userInfo"
        />
      </transition>
    </div>
    <VuePerfectScrollbar class="bb-notification-body">
      <NotificationsBarMain :notificationsList.sync="notificationsList"/>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import NotificationsBarMain from '@/components/Notifications/NotificationsBar/NotificationsBarMain'
import TimeoffNotificationApi from '@/api/NotificationTimeoff/api'
import {NOTIFICATION_ALL_HR} from '@/constants/notificationHr'
import {EVENT_CATEGORY} from '@/constants/eventCategory'
import NotificationsBarPopupMenu from '@/components/Notifications/NotificationsBar/NotificationsBarPopupMenu'

export default {
  name: 'NotificationsBar',
  components: {
    NotificationsBarPopupMenu,
    NotificationsBarMain,
    VuePerfectScrollbar
  },
  data: () => ({
    isShowPopup: false
  }),
  computed: {
    openNotifications: {
      get () {
        return this.$store.getters.openNotifications
      },
      set (data) {
        this.$store.dispatch('setOpenNotifications', data)
      }
    },
    notificationsList: {
      get () {
        return this.$store.getters.notificationsList
      },
      set (data) {
        this.$store.dispatch('setNotificationsList', data)
      }
    },
    countNotifications () {
      return this.notificationsList.length
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    userInfo () {
      this.getNotification()
    }
  },
  methods: {
    hideNotificationBar () {
      this.openNotifications = false
    },
    async getNotification () {
      const { id } = this.userInfo
      if (!id) return
      try {
        const { data } = await TimeoffNotificationApi.getNotificationTimeoff({user: id})
        const { userNotification = [] } = data
        userNotification.forEach((notification) => {
          const { notificationStatus, eventType } = notification
          const newNotificationStatus = NOTIFICATION_ALL_HR.find(({id}) => id === notificationStatus)
          notification.notificationStatus = newNotificationStatus
          notification.eventType = EVENT_CATEGORY.find(({id}) => id === eventType)
        })
        this.notificationsList = userNotification
      } catch (err) {
        console.error(err)
      }
    }
  },
  beforeMount () {
    this.getNotification()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/transition";
@import "../../../sass/mixins";

.bb-notification {
  @include global-font();
  position: fixed;
  left: 279px;
  height: 100vh;
  background: $color-white;
  box-shadow: 4px 4px 30px rgba($color-black, 0.06);
  z-index: -1;
  width: 0;
  overflow: hidden;
  transition: all 0.3s ease-out;
  pointer-events: none;

  &_open {
    width: 398px;
    z-index: 99;
    pointer-events: auto;
  }

  &-header {
    display: flex;
    align-items: center;
    padding: 25px 22px;
    border-bottom: 1px solid $color-wild-sand;
    position: relative;

    &__title {
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
    }

    &__count {
      margin-left: 8px;
      padding: 3px;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      color: $color-accent;
      background: rgba($color-accent, 0.14);
      border-radius: 3px;
      min-width: 20px;
      min-height: 19px;
      max-height: 19px;
      text-align: center;
    }

    &__icon {
      position: absolute;
      transform: rotate(90deg);
      color: $color-denim;
      right: 24px;
      cursor: pointer;
    }
  }

  &-body {
    height: calc(100vh - 70px);
    padding: 0 22px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsBar/NotificationsBar.vue